import { jsxs as t, jsx as C } from "react/jsx-runtime";
const l = ({ ...H }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 144 55", fill: "none", ...H, children: [
  /* @__PURE__ */ C(
    "path",
    {
      d: "M31.0479 1.71893C31.0071 1.62398 30.912 1.56294 30.8102 1.56294H24.4475C24.3422 1.56294 24.2506 1.62398 24.2098 1.71893L2.02189 53.5761C1.9472 53.7456 2.07282 53.9389 2.25956 53.9389H7.91944C8.02469 53.9389 8.11636 53.8779 8.1571 53.783L15.1853 37.3506H40.0622L47.0938 53.783C47.1345 53.8779 47.2296 53.9389 47.3315 53.9389H52.9913C53.1781 53.9389 53.3037 53.749 53.229 53.5761L31.0479 1.71893ZM27.5066 8.52448H27.7443L37.6278 31.6539H17.6231L27.5066 8.52448Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      d: "M99.6726 25.9571H70.9114C70.7688 25.9571 70.65 26.0724 70.65 26.2182V31.3961C70.65 31.5385 70.7654 31.6572 70.9114 31.6572H94.2436C93.955 36.4248 89.4732 48.9949 74.6054 48.9949C61.7918 48.9949 54.1016 39.0935 54.1016 27.4932C54.1016 15.8929 62.1924 6.65943 74.8703 6.65943C83.5146 6.65943 89.0454 10.5352 91.8771 16.1777C91.9212 16.2659 92.0095 16.3201 92.1079 16.3201H97.9376C98.1141 16.3201 98.2431 16.1472 98.1854 15.9776C95.8122 8.99237 88.672 1 74.7073 1C59.045 1 48.2651 12.7698 48.2651 27.5678C48.2651 42.3861 58.2098 54.6611 74.6054 54.6611C89.2695 54.6611 100.155 44.1188 100.155 27.8289C100.155 27.3643 100.155 26.7913 100.094 26.4047C100.056 26.1605 99.9713 25.9503 99.6726 25.9503V25.9571Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      d: "M139.122 3.96711C139.387 3.8959 139.618 3.67549 139.618 3.30588C139.618 2.8888 139.292 2.59379 138.718 2.59379H137.754V5.0895H138.222V4.12988H138.535C138.844 4.12988 138.956 4.28925 139.04 4.51983C139.115 4.72667 139.173 4.94708 139.254 5.09289H139.733V5.07255C139.645 4.90978 139.59 4.72668 139.519 4.49948C139.434 4.22821 139.353 4.03493 139.122 3.96711ZM138.691 3.75348H138.222V2.97697H138.681C139.007 2.97697 139.152 3.13634 139.152 3.34997C139.152 3.59411 138.983 3.75348 138.691 3.75348Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      d: "M138.647 1.02376C137.061 1.02376 135.774 2.30891 135.774 3.89247C135.774 5.47602 137.061 6.76118 138.647 6.76118C140.232 6.76118 141.519 5.47602 141.519 3.89247C141.519 2.30891 140.232 1.02376 138.647 1.02376ZM138.647 6.27628C137.329 6.27628 136.256 5.20475 136.256 3.88908C136.256 2.57341 137.329 1.50188 138.647 1.50188C139.964 1.50188 141.037 2.57341 141.037 3.88908C141.037 5.20475 139.964 6.27628 138.647 6.27628Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      d: "M104.314 48.2354L107.909 43.461L133.577 7.96159C133.71 7.78865 133.785 7.57502 133.785 7.35801V1.93933C133.785 1.7291 133.615 1.55955 133.404 1.55955H98.817C98.6065 1.55955 98.4367 1.7291 98.4367 1.93933V6.86632C98.4367 7.07656 98.6065 7.24611 98.817 7.24611H126.668L123.823 10.9863L97.6286 47.3707C97.4962 47.5437 97.4249 47.7539 97.4249 47.9709V53.5558C97.4249 53.766 97.5947 53.9355 97.8052 53.9355H133.408C133.618 53.9355 133.788 53.766 133.788 53.5558V48.6118C133.788 48.4016 133.618 48.232 133.408 48.232H104.317L104.314 48.2354Z",
      fill: "white"
    }
  )
] });
export {
  l as LogoAGZIcon
};
